import React from 'react'

// icons
import { AiOutlineQuestionCircle } from 'react-icons/ai'

// react router
import { Link } from 'react-router-dom'

export default function ItemsOrdered(props) {
    // props
    const { ordersList, orderDetails } = props

    return (
        <div className="ordered-items-table table-responsive">
            <table className="table">
                <thead>
                    <tr>
                        <th className="st-fs-13">product name</th>
                        <th className="st-fs-13">SKU</th>
                        <th className="st-fs-13 text-end">Price</th>
                        <th className="st-fs-13 text-end">Qty</th>
                        <th className="st-fs-13 text-end">Subtotal</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        ordersList?.length && ordersList.map(item => (
                            <tr key={item.order_item_id}>
                                <td>
                                    <Link
                                        // to={`/product/${item.order_item_id}?id=${item.order_item_id}`}
                                        to={`/product/${item.product_url}?id=${item.product_id}`}
                                        target="_blank"
                                        className="name mb-2 st-fs-15 st-fw-700 text-dark hover-underline-link">{item.product_name}
                                    </Link> <br />
                                    {
                                        item.variant_name
                                    }
                                    {/* <p className="size mb-2">
                                        <span className="d-block st-fw-800 st-fs-13">Size</span>
                                        18' x 25"
                                    </p>
                                    <p className="color mb-2">
                                        <span className="d-block st-fw-800 st-fs-13">Color</span>
                                        Natural
                                    </p> */}
                                </td>

                                <td>
                                    <p className="sku mb-0">
                                        {item.sku}
                                    </p>
                                </td>

                                <td>
                                    <p className="price mb-0 st-fw-800 text-end">
                                        {item.currency_price}
                                    </p>
                                </td>

                                <td>
                                    <p className="qty mb-0 text-end">
                                        <span className="d-block">Ordered: {item.quantity}</span>
                                        {/* <span className="d-block">Shipped: {item.quantity}</span> */}
                                    </p>
                                </td>

                                <td>
                                    <p className="subtotal st-fw-800 mb-0 text-end">
                                        {item.current_total_price}
                                    </p>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>

                <tfoot>
                    <tr>
                        <td colSpan={4}>
                            <p className="text-end mb-0">Subtotal</p>
                        </td>
                        <td>
                            <p className="text-end mb-0">{orderDetails?.currency_sub_total}</p>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                            <p className="text-end mb-0">Discount</p>
                        </td>
                        <td>
                            <div className="d-flex align-items-center justify-content-end">
                                {
                                    orderDetails?.coupon_code ? (
                                        <div className="discount-info position-relative ms-2">
                                            <p className="text-end text-danger mb-0">{orderDetails?.currency_promo_discount}</p>

                                            <div className="content position-absolute">
                                                <div className="inner">
                                                    <p className="mb-0">
                                                        {orderDetails?.currency_promo_discount} ({orderDetails?.coupon_discount_with_type}) for
                                                        applied coupon
                                                        <span className="d-block st-fw-600">
                                                            '{orderDetails?.coupon_code}'
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <p className="text-end text-danger mb-0">{orderDetails?.currency_promo_discount}</p>
                                    )
                                }
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                            <p className="text-end mb-0">Shipping</p>
                        </td>
                        <td>
                            <p className="text-end mb-0">{orderDetails?.currency_shipping}</p>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                            <p className="text-end mb-0">Estimated Tax</p>
                        </td>
                        <td>
                            <p className="text-end mb-0">{orderDetails?.currency_tax ?? "$0.00"}</p>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                            <p className="text-end mb-0 st-fw-800">Grand Total</p>
                        </td>
                        <td>
                            <p className="text-end mb-0 st-fw-800">{orderDetails?.currency_order_amount}</p>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}
